
import React from 'react';
import { Twitter, Facebook, Instagram } from "lucide-react";

interface SocialLinksProps {
  darkMode: boolean;
}

const SocialLinks = ({ darkMode }: SocialLinksProps) => {
  const socialLinks = [
    {
      icon: Twitter,
      url: "https://x.com/Cibeto07",
      label: "Twitter"
    },
    {
      icon: Facebook,
      url: "https://www.facebook.com/profile.php?id=61574970732236",
      label: "Facebook"
    },
    {
      icon: Instagram,
      url: "https://www.instagram.com/cibeto07/",
      label: "Instagram"
    }
  ];

  return (
    <div className="flex justify-center gap-4">
      {socialLinks.map((social) => (
        <a
          key={social.label}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-gray-500 hover:text-[#8B5CF6] transition-colors ${darkMode ? 'text-gray-400 hover:text-purple-400' : ''}`}
          title={social.label}
        >
          <social.icon className="w-5 h-5" />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
